import React, { useEffect, useState } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Topup from '../Topup';
import Cashout from '../Cashout';
import { withRouter, useParams } from 'react-router-dom';
import TransfersDueLoan from '../TransfersDueLoan';
import TransferDueInstallments from '../TransferDueInstallments';
import qs from 'query-string';

const tabsWallet = [
	'Wallet Top-ups', //Top-ups to the wallet
	'Loan Fund Transfer', //Transfer due to loan
	'Installment Transactions', //Transfer due to installment
	'Wallet Cash-outs' //Cash-outs from the wallet
];

const TabsWallet = props => {
	const [state, setState] = useState({
		selectedIndex:
			props.location.search === '?page=0&tab=2&notification=true'
				? 2
				: props.location.search === '?page=0&tab=2&transferdue=true'
				? 1
				: 0
	});

	return (
		<Tabs
			className="tabs_wallet"
			selectedIndex={Number(state.selectedIndex)}
			onSelect={selectedIndex => {
				props.history.push({
					search: '?page=0&tab=2' // reset to original query  onclick
				});
				setState({ selectedIndex });
			}}>
			<TabList>
				{tabsWallet.map(m => (
					<Tab key={m}>{m}</Tab>
				))}
			</TabList>
			<TabPanel>
				<Topup />
			</TabPanel>
			<TabPanel>
				<TransfersDueLoan />
			</TabPanel>
			<TabPanel>
				<TransferDueInstallments />
			</TabPanel>
			<TabPanel>
				<Cashout />
			</TabPanel>
		</Tabs>
	);
};

export default withRouter(TabsWallet);
